import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import EngagementForm from "./EngagementForm";
import NewEngagementModal from "./NewEngagementModal";

export default function EngagementCreatePage() {
  const navigate = useNavigate();
  const { engagementId } = useParams();
  if (engagementId) return <EngagementForm engagementId={engagementId} />;
  return <NewEngagementModal isOpen onCancel={() => navigate("/engagements/list")}
    onSaved={() => navigate("/engagements/list")} />;
}
